import { useTranslation } from "react-i18next"
import SeoHead from "./SeoHead"
import ServicePage, { RelatedServices, ServiceCta, ServiceFaq, ServiceHero } from "../services/ServicePageLayout"
import mobileInspectionImg from "../../assets/service-mobile-inspection-hero.jpg"

const MobileCarInspection = () => {
  const { t, i18n } = useTranslation()
  const isRTL = i18n.dir() === "rtl"
  const lang = i18n.language === 'en' ? 'en' : 'ar'
  const faq = t('portable_inspection_faq', { returnObjects: true })
  const steps = t('portable_inspection_steps', { returnObjects: true })
  const areas = t('portable_inspection_coverageAreas', { returnObjects: true })
  const ctaMessage = isRTL
    ? 'مرحباً، أرغب في طلب الفحص المتنقل.'
    : 'Hi, I need the mobile inspection service.'

  return (
    <ServicePage isRTL={isRTL}>
      <SeoHead
        path="mobile-car-inspection"
        title={t('portable_inspection_metaTitle')}
        description={t('portable_inspection_metaDescription')}
        keywords={t('portable_inspection_keywords')}
        jsonLd={{
          '@context': 'https://schema.org',
          '@type': 'Service',
          serviceType: 'Mobile car inspection',
          provider: { '@type': 'AutomotiveBusiness', name: 'Al Professor Car Inspection' },
          areaServed: areas,
          description: t('portable_inspection_metaDescription'),
        }}
      />

      <ServiceHero
        eyebrow={t('portable_inspection_eyebrow')}
        title={t('portable_inspection_title')}
        intro={t('portable_inspection_description')}
        image={mobileInspectionImg}
        imageAlt={t('portable_inspection_title')}
        ctaLabel={t('portable_inspection_ctaLabel')}
        ctaMessage={ctaMessage}
      />

      <section className="service-section">
        <div className="service-section-head">
          <h2>{t('portable_inspection_howTitle')}</h2>
        </div>
        <ul className="service-steps">
          {steps.map((step, index) => (
            <li key={step.title}>
              <span className="service-step-index">0{index + 1}</span>
              <h3>{step.title}</h3>
              <p>{step.body}</p>
            </li>
          ))}
        </ul>
      </section>

      <section className="service-section">
        <div className="service-section-head">
          <h2>{t('portable_inspection_coverageTitle')}</h2>
        </div>
        <ul className="service-coverage-chips">
          {areas.map((area) => <li key={area}>{area}</li>)}
        </ul>
      </section>

      <ServiceFaq title={t('portable_inspection_faqTitle')} items={faq} />
      <RelatedServices title={t('portable_inspection_related.title')} items={t('portable_inspection_related.items', { returnObjects: true })} lang={lang} />

      <ServiceCta
        eyebrow={t('portable_inspection_eyebrow')}
        title={t('portable_inspection_title')}
        body={t('portable_inspection_metaDescription')}
        ctaLabel={t('portable_inspection_ctaLabel')}
        ctaMessage={ctaMessage}
      />
    </ServicePage>
  )
}

export default MobileCarInspection
